import dictStore, * as DictStore from './dictStore';

export type ViewType = DictStore.ViewType;
export type DictionaryModel = DictStore.DictionaryModel;

export default dictStore;
